import { createContext, type Context } from 'react';

type TeamInlinePreviewContextValues = {
	teamId: string;
	isVerified?: boolean;
	isArchived?: boolean;
	singleLine?: boolean;
	preserveBadges?: boolean;
	getTestId: (suffix: string) => string | undefined;
};

const TeamInlinePreviewContext: Context<TeamInlinePreviewContextValues> =
	createContext<TeamInlinePreviewContextValues>({
		teamId: '',
		isVerified: false,
		isArchived: false,
		singleLine: false,
		preserveBadges: true,
		getTestId: () => undefined,
	});

export { TeamInlinePreviewContext };
export type { TeamInlinePreviewContextValues };
